import { SxProps } from '@mui/material';

export const TopBarLanguageChangeLanguageIconStyles: SxProps = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
  padding: 0,
  width: '100%',
};
